import { Module } from '@nestjs/common';
import { AuditModule } from 'src/audit/audit.module';
import { PrismaModule } from '../prisma/prisma.module';
import { PreciosEngineService } from './precios-engine.service';
import { ReglasPrecioController } from './reglas-precio.controller';

@Module({
  imports: [PrismaModule, AuditModule],
  controllers: [ReglasPrecioController],
  providers: [PreciosEngineService],
  exports: [PreciosEngineService],
})
export class ReglasPrecioModule {}
